import { UserInfoService } from "./user-info-service";

const userInfoService = new UserInfoService();

export const userInfoQueryOptions = {
  queryKey: ["user-info"],
  queryFn: () => userInfoService.getUserInfo(),
  staleTime: Infinity,
} as const;
